import React, { useState } from "react";
import infoimg from "../../images/Info Square.png";
import donateimg1 from "../../images/Frame 1321316476.png";
import donateimg2 from "../../images/Frame 1321316477.png";
import { useSelector, useDispatch } from "react-redux";
import { setdonationfee, setshowdonation } from "../../redux/paymentslice";

const Donation = ({ donation }) => {
    const donationfee = useSelector((state) => state.paymentslice.donationfee);
    const showdonation = useSelector((state) => state.paymentslice.showdonation);
    const dispatch = useDispatch();

    const handleChange = (e) => {
        const value = e.target.value;
        dispatch(setdonationfee(value));
    };

    const handleCheckboxToggle = () => {
        dispatch(setshowdonation(!showdonation));
    
    };

    return (
        <div>
            <div className="dinate-titleclass">
                <div className="d-flex justify-content-center">
                    <input
                        type="checkbox"
                        className="donatecheckbox"
                        checked={showdonation}
                        onChange={handleCheckboxToggle}
                    />
                    Donate and make a difference
                </div>
                <img src={infoimg} alt="info" />
            </div>

            <div className="ps-3">
                <img src={donateimg1} alt="donation1" />
                <img src={donateimg2} alt="donation2" />
            </div>

            <div>
                <input
                    type="text"
                    placeholder="ENTER AMOUNT MANUALLY"
                    className="donate-input"
                    value={donationfee}
                    onChange={handleChange}
                />
            </div>
        </div>
    );
};

export default Donation;
